import React from 'react';

export default function HighlightText({ text, phrase }) {
	if (!phrase || phrase.length < 3) return text;

	if (!text.toLowerCase().includes(phrase.toLowerCase())) return text;

	return <mark style={{ backgroundColor: 'rgb(226, 226, 226)', padding: 0 }}>{text}</mark>;
}
